var _rect, _rect2, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAaJcb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 32,
    viewBox: "0 0 46 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45,
    height: 31,
    rx: 3.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45,
    height: 31,
    rx: 3.5,
    stroke: "#F2F4F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.309 15.9391C30.0174 15.9545 30.7298 15.9078 31.4353 15.9633C32.1498 16.0966 32.322 17.1782 31.6872 17.5325C31.2541 17.7659 30.7396 17.6194 30.2701 17.6606H29.309V15.9391ZM31.8449 13.9905C32.0022 14.546 31.4668 15.0448 30.9318 14.9683H29.309C29.3204 14.4444 29.2868 13.8758 29.3255 13.3796C29.9756 13.3979 30.6316 13.3422 31.2779 13.4087C31.5556 13.4784 31.788 13.7067 31.8449 13.9905ZM35.7501 5.75272C35.7803 6.81358 35.7545 7.9305 35.7631 9.01287C35.7611 13.4134 35.7674 17.8138 35.7597 22.2146C35.7312 23.8638 34.2696 25.2968 32.6318 25.3297C30.9924 25.3364 29.3528 25.3308 27.7132 25.3326V18.6799C29.4996 18.6707 31.287 18.6986 33.0727 18.666C33.901 18.614 34.8084 18.0674 34.847 17.1558C34.9445 16.2402 34.0813 15.6069 33.2618 15.5069C32.9468 15.4987 32.956 15.4151 33.2618 15.3786C34.0434 15.2097 34.6572 14.4007 34.4273 13.5905C34.2313 12.7383 33.2894 12.4085 32.506 12.4101C30.9087 12.3993 29.311 12.4086 27.7136 12.4055C27.7239 11.1635 27.692 9.92018 27.7307 8.67912C27.8573 7.05968 29.3557 5.72417 30.9704 5.75315C32.5639 5.75291 34.157 5.75291 35.7501 5.75285V5.75272Z",
    fill: "url(#paint0_linear_18346_202103)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66163 8.8469C9.70242 7.20031 11.1703 5.77903 12.8059 5.75496C14.4393 5.74993 16.0728 5.75424 17.7061 5.75278C17.7016 11.2619 17.715 16.7717 17.6994 22.2805C17.6365 23.9071 16.1847 25.3013 14.5668 25.3301C12.9304 25.336 11.2938 25.331 9.65733 25.3326V18.4556C11.2469 18.8311 12.9138 18.991 14.5354 18.7419C15.5047 18.5859 16.5653 18.1099 16.8934 17.1043C17.1349 16.2441 16.999 15.3388 17.0349 14.4559V12.4055H14.2286C14.2159 13.7616 14.2544 15.12 14.2082 16.4744C14.1326 17.3069 13.3081 17.8359 12.523 17.8076C11.5492 17.8179 9.61962 17.1019 9.61962 17.1019C9.61477 14.5612 9.64787 11.3794 9.66163 8.84714V8.8469Z",
    fill: "url(#paint1_linear_18346_202103)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7525 13.2326C18.6048 13.2639 18.7228 12.7294 18.6851 12.5267C18.6951 11.2446 18.664 9.96118 18.7022 8.68005C18.8284 7.05376 20.3383 5.71492 21.9596 5.75299H26.7342C26.7297 11.2621 26.743 16.7719 26.7275 22.2807C26.6645 23.9073 25.2126 25.3015 23.5947 25.3303C21.9582 25.3365 20.3216 25.3313 18.685 25.3329V17.7982C19.8027 18.7153 21.3218 18.858 22.7143 18.8605C23.764 18.8601 24.8077 18.6983 25.8271 18.4562V17.0758C24.6782 17.6484 23.3277 18.0121 22.0542 17.6831C21.1658 17.462 20.5209 16.6034 20.5352 15.6866C20.4323 14.7332 20.9912 13.7266 21.9281 13.4431C23.0914 13.0789 24.3593 13.3575 25.4497 13.831C25.6833 13.9533 25.9205 14.105 25.827 13.7145V12.6295C24.0033 12.1956 22.0625 12.036 20.2303 12.508C19.7 12.6576 19.1833 12.8845 18.7525 13.2327V13.2326Z",
    fill: "url(#paint2_linear_18346_202103)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18346_202103",
    x1: 27.6582,
    y1: 15.124,
    x2: 35.7124,
    y2: 15.124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58B03A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55B330"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_18346_202103",
    x1: 9.48608,
    y1: 15.7302,
    x2: 17.5742,
    y2: 15.7302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F6EB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006DBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_18346_202103",
    x1: 18.6732,
    y1: 15.314,
    x2: 26.7327,
    y2: 15.314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE0D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E30138"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAaJcb);
export default __webpack_public_path__ + "static/media/aa-jcb.01f5f2a06922ff488dabf1892ea5f222.svg";
export { ForwardRef as ReactComponent };